module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-email-39cf0897f3ba4c3578f30448d57d1074.png";